export const MAX_TRIAL_DAYS = 90
